/* Seitenleiste: Objekt-Eigenschaften, Texturen, Entities, Generatoren, Prüfung. */
import EntDefs from './model/entdefs.ts';
import I18n from './i18n.ts';
import Leak from './formats/leak.ts';
import Limits from './analysis/limits.ts';
import { countTextures } from './model/texlist.ts';
import { defaultValues } from './model/genspecs.ts';
import { refreshCheckDialog } from './ui/check/CheckPanel.tsx';
import { mountEntitiesPanel } from './ui/build/EntitiesPanel.tsx';
import { mountGeneratorsPanel } from './ui/build/GeneratorsPanel.tsx';
import { mountLayersPanel } from './ui/check/LayersPanel.tsx';
import { createElement } from 'react';
import { openDialog } from './ui/modal.tsx';
import { WarningsDialog } from './ui/dialogs/SmallDialogs.tsx';
import { mountPropsPanel } from './ui/props/PropsPanel.tsx';
import { mountTexturePanel } from './ui/texture/TexturePanel.tsx';
const _ = I18n.t;
const Panels = (function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  const GROUPS = [['player', 'pn.g.player'], ['light', 'pn.g.light'], ['monster', 'pn.g.monster'], ['item', 'pn.g.item'], ['func', 'pn.g.func'], ['trigger', 'pn.g.trigger'], ['other', 'pn.g.other']];

  function create(app) {
    const h = app.h;
    const P = { tab: 'props', texFilter: '', entFilter: '', gen: defaultValues(), genOpen: 'room', checkRes: null };

    // ---------------------------------------------------------- Hilfen
    const btn = (t, cb, cls, title) => h('button', { class: 'btn sm ' + (cls || ''), text: t, title: title || '', on: { click: cb } });

    P.fillClassSelect = function (sel, current, kind) {
      sel.textContent = '';
      GROUPS.forEach((g) => {
        const items = EntDefs.list.filter((d) => d.g === g[0] && (!kind || d.k === kind));
        if (!items.length) return;
        const og = h('optgroup', { label: _(g[1]) });
        items.forEach((d) => og.append(h('option', { value: d.c, text: d.c, selected: d.c === current })));
        sel.append(og);
      });
    };

    P.showTab = function (t) {
      P.tab = t;
      $$('#tabs [data-tab]').forEach((b) => b.setAttribute('aria-selected', String(b.dataset.tab === t)));
      $$('#panels section').forEach((s) => { s.hidden = s.id !== 'p-' + t; });
      P.render();
    };
    P.render = function () {
      ({ props: renderProps, tex: renderTex, ents: renderEnts, build: renderBuild, layers: renderLayers })[P.tab]();
    };
    P.selChanged = function (previewOnly) {
      if (P.tab === 'props') { if (previewOnly) { if (propsPanel) propsPanel.live(); } else renderProps(); }
      if (P.tab === 'ents' && !previewOnly) renderEnts();
      if (P.tab === 'tex' && app.tool === 'texture' && !previewOnly) renderTexMode();
      if (P.tab === 'layers' && !previewOnly) renderLayers();
    };
    P.docChanged = function () {
      refreshTexList();
      if (P.tab === 'tex') { renderTexHead(); if (app.tool === 'texture') renderTexMode(); } else P.render();
    };
    P.texChanged = function () { if (P.tab === 'tex') { renderTexHead(); markThumbs(); if (app.tool === 'texture') renderTexMode(); } if (P.tab === 'props') renderProps(); app.renderOpts(); };
    P.wadsChanged = function () { refreshTexList(); if (P.tab === 'tex') renderTex(); };
    P.mapLoaded = function () { P.checkRes = null; };
    P.showWarnings = function (w) {
      openDialog((close) => createElement(WarningsDialog, { warnings: w, onClose: () => close() }));
    };

    let dl = null;
    function refreshTexList() {
      if (!dl) { dl = h('datalist', { id: 'dl-tex' }); document.body.append(dl); }
      const names = new Set(countTextures(app.doc).map((x) => x[0]));
      app.wads.names().slice(0, 1500).forEach((n) => names.add(n));
      dl.textContent = '';
      names.forEach((n) => dl.append(h('option', { value: n })));
    }
    P.faceScopeSel = false;
    P.hollow = { t: 16, tex: '' };
    P.align = { tx: 1, ty: 1, step: 16, deg: 15, withTex: true, pick: null };
    app.openSoundFiles = () => $('#f-snd').click();
    let propsPanel = null;
    function renderProps() {
      if (!propsPanel) propsPanel = mountPropsPanel($('#p-props'), app, P);
      propsPanel.refresh();
    }

    // ---------------------------------------------------------- Texturen
    // ---------------------------------------------------------- Textur-Seite (React, siehe ui/texture/TexturePanel.tsx)
    let texPanel = null;
    function renderTex() {
      if (!texPanel) texPanel = mountTexturePanel($('#p-tex'), app, P);
      texPanel.refresh();
    }
    const renderTexMode = renderTex, renderTexHead = renderTex, markThumbs = renderTex;

    // ---------------------------------------------------------- Entities und Generatoren (React, siehe ui/build/)
    let entsPanel = null, buildPanel = null;
    function renderEnts() {
      if (!entsPanel) entsPanel = mountEntitiesPanel($('#p-ents'), app, P);
      entsPanel.refresh();
    }
    function renderBuild() {
      if (!buildPanel) buildPanel = mountGeneratorsPanel($('#p-build'), app, P);
      buildPanel.refresh();
    }

    // ---------------------------------------------------------- Leak
    // ---------------------------------------------------------- Prüfung, Limits, Leak und Ebenen (React, siehe ui/check/)
    P.leakIdx = 0;
    let layersPanel = null;
    function renderLayers() {
      if (!layersPanel) layersPanel = mountLayersPanel($('#p-layers'), app);
      layersPanel.refresh();
    }
    P.leakChanged = function () { refreshCheckDialog(); };
    P.visChanged = function () { if (P.tab === 'layers') renderLayers(); };

    // Tabs
    $$('#tabs [data-tab]').forEach((b) => b.addEventListener('click', () => {
      P.showTab(b.dataset.tab);
    }));
    refreshTexList();
    return P;
  }
  return { create: create };
})();
export default Panels;
